export const GIT_COMMIT = '00a2088e5a0990d359cc888a6a20008c989962c6'
